import { createCrudSlice } from '../createCrudSlice';
import bannersService from '@/services/banners.service';

const { reducer, thunks } = createCrudSlice('banners', bannersService);
export const { fetchList: fetchBanners, createItem: createBanner, updateItem: updateBanner, deleteItem: deleteBanner } = thunks;
export default reducer;
